module.exports = __webpack_public_path__ + "static/media/arrow_02.c85ed9f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/arrow_02.png
// module id = 1732
// module chunks = 0 1